var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { UserAvatarModel } from '../model/user-avatar-model.interface';
import { UserAvatarRepository } from '../repository/user-avatar-repository.interface';
import { batchProxy } from '@/infrastructure/utils/batch-proxy';
import _ from 'lodash';
let UserAvatarServiceImpl = class UserAvatarServiceImpl {
    constructor(_userAvatarModel, _userAvatarRepository) {
        this._userAvatarModel = _userAvatarModel;
        this._userAvatarRepository = _userAvatarRepository;
        this._batchFn = batchProxy((useIds) => {
            /* batchProxy 没有去重逻辑，此处的接口接收重复 id 时会报错 */
            const _useIds = _.uniq(useIds);
            return this._userAvatarRepository.getAvatarByIds(_useIds);
        }, 500);
    }
    get userAvatarSet() {
        return this._userAvatarModel.modelData;
    }
    async fetchUserAvatarById(userId) {
        if (this._userAvatarModel.getUserAvatarById(userId))
            return;
        const avatarSet = await this._batchFn([userId]);
        this._userAvatarModel.updateUserAvatars(avatarSet);
    }
    subscribe(callback) {
        return this._userAvatarModel.onStatesChange(callback);
    }
};
UserAvatarServiceImpl = __decorate([
    injectable(),
    __param(0, inject(UserAvatarModel)),
    __param(1, inject(UserAvatarRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof UserAvatarModel !== "undefined" && UserAvatarModel) === "function" ? _a : Object, typeof (_b = typeof UserAvatarRepository !== "undefined" && UserAvatarRepository) === "function" ? _b : Object])
], UserAvatarServiceImpl);
export { UserAvatarServiceImpl };
